export enum EnumTraceabilityPageNames {
  TRACEABILITY_CREATE_OFFER = "create_traceability_offer",
  TRACEABILITY_DISCOVER = "discover_traceability_data",
  TRACEABILITY_NOTIFICATIONS = "traceability_notifications",
  TRACEABILITY_INDUSTRY_CORE_NOTIFICATIONS = "industry_core_notifications",
  TRACEABILITY_CONTRACT_AGREEMENTS = "contract_agreements",
  TRACEABILITY_EXCHANGE_HISTORY = "exchange_history"
}

export enum EnumExchangeHistoryType {
  UPLOAD = "UPLOAD",
  DOWNLOAD = "DOWNLOAD"
}

export enum EnumDigitalTwinBrowserType {
  PROVIDE = "PROVIDE",
  CONSUME = "CONSUME"
}
